module.exports = __webpack_public_path__ + "static/media/xiconnnn.7c95335e.svg";